export default "__VITE_ASSET__ed8e8375__"